<template>
  <div>
    <b-container>
      <b-row class="justify-content-center">
        <b-col md="10">
          <h1>Instyle Fragrances</h1>
          <h2>Shopify E-Commerce Website</h2>
          <p>Designer fragrances are expensive, so Instyle Fragrances created an affordable alternative inspired by great designers. My team and I developed a custom Shopify theme allowing users to learn about and purchase various products from Instyle Fragrances.</p>
          
          <b-button variant="primary" href="http://instylefragrances.com" target="_blank">
            Visit Website <font-awesome-icon icon="external-link-alt" class="ml-2" />
          </b-button>
        </b-col>
      </b-row>

      <b-row class="mt-3 mt-lg-0">
        <b-col lg="6">
          <b-img fluid class="mt-3 mt-lg-5 w-100 border shadow" alt=""
            :src="require('../../assets/screens/instyle-home.png')"
            :srcset="require('../../assets/screens/instyle-home@2x.png') + ' 2x'" />
        </b-col>

        <b-col lg="6">
          <b-img fluid class="mt-3 mt-lg-5 w-100 border shadow" alt=""
            :src="require('../../assets/screens/instyle-womens-fragrances.png')"
            :srcset="require('../../assets/screens/instyle-womens-fragrances@2x.png') + ' 2x'" />

          <b-img fluid class="mt-3 mt-lg-5 w-100 border shadow" alt=""
            :src="require('../../assets/screens/instyle-mens-fragrances.png')"
            :srcset="require('../../assets/screens/instyle-mens-fragrances@2x.png') + ' 2x'" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  export default {
    metaInfo: {
      titleTemplate: 'Instyle Fragrances | %s',
    }
  }
</script>
